// extracted by mini-css-extract-plugin
export default {"root":"styles__root--t52Xx","wrapper":"styles__wrapper--zrXbs","title-only":"styles__title-only--5Iy6K"};